var $name="getHeaderHeightReduced",$path="app/utilities/getHeaderHeightReduced.js",$this={$name,$path,};import { css } from 'configs';

import getCSSVariable from './getCSSVariable';
import parseDecimal from './parseDecimal';

const getHeaderHeightReduced = () => parseDecimal(getCSSVariable(css.variableNames.headerHeightReduced));

export default getHeaderHeightReduced;
